import { Image, useWindowDimensions } from 'tamagui'
import { Gesture, GestureDetector } from 'react-native-gesture-handler'
import Animated, {
  useAnimatedStyle,
  useSharedValue,
} from 'react-native-reanimated'
import { Platform } from 'react-native'

interface IZoomableImageProps {
  uri: string
  width: number
  height: number
  objectFit: 'fill' | 'contain' | 'cover'
}

export function ZoomableImage({
  uri,
  width,
  height,
  objectFit,
}: IZoomableImageProps) {
  const scale = useSharedValue(1)
  const savedScale = useSharedValue(1)
  const offsetX = useSharedValue(0)
  const offsetY = useSharedValue(0)
  const savedOffsetX = useSharedValue(0)
  const savedOffsetY = useSharedValue(0)
  const { width: windowWidth, height: windowHeight } = useWindowDimensions()

  const pinchGesture = Gesture.Pinch()
    .onUpdate((e) => {
      scale.value = savedScale.value * e.scale
    })
    .onEnd(() => {
      savedScale.value = scale.value
    })

  const panGesture = Gesture.Pan()
    .onUpdate((e) => {
      offsetX.value = savedOffsetX.value + e.translationX
      offsetY.value = savedOffsetY.value + e.translationY
    })
    .onEnd(() => {
      savedOffsetX.value = offsetX.value
      savedOffsetY.value = offsetY.value
    })

  const composed = Gesture.Simultaneous(
    Platform.OS === 'ios'
      ? pinchGesture.cancelsTouchesInView(false)
      : pinchGesture,
    Platform.OS === 'ios' ? panGesture.cancelsTouchesInView(false) : panGesture,
  )

  const animatedStyle = useAnimatedStyle(() => ({
    transform: [
      { translateX: offsetX.value },
      { translateY: offsetY.value },
      { scale: scale.value },
    ],
  }))

  return (
    <GestureDetector gesture={composed}>
      <Animated.View
        style={[
          animatedStyle,
          { maxWidth: windowWidth, maxHeight: windowHeight },
        ]}
      >
        <Image
          alt=""
          source={{ uri }}
          style={{
            width,
            height,
            objectFit,
          }}
        />
      </Animated.View>
    </GestureDetector>
  )
}
